(() => {
  if (window.__lsb_bound) return;
  window.__lsb_bound = true;

  /* ---------- CONFIG ---------- */
  const OPEN_HOUR      = 7;
  const PRE_CLOSE_HOUR = 17;
  const CLOSE_HOUR     = 19;
  const START_MIN      = 10;
  const START_MAX      = 15;
  const FLOOR_MIN      = 2;
  const FLOOR_MAX      = 5;
  const PRE_ORDER_TOKEN = 'pre';

  /* ---------- HELPERS ---------- */
  const rand = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
  const todayStamp = (d) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
  const key  = (kind, pid, vid, date) => `ls-${kind}-${pid}-${vid}-${date}`;
  const load = (k, fb) => { const v = localStorage.getItem(k); return v ? parseInt(v,10) : fb; };
  const save = (k, v) => localStorage.setItem(k, v);
  const isPreOrderText = (txt) =>
    txt && txt.toLowerCase().includes(PRE_ORDER_TOKEN);

  function getBadgeForInput(input) {
    const form = input.closest('form') || document;
    return (form.querySelector('.limited-stock-badge') || document.querySelector('.limited-stock-badge'));
  }

  /* ---------- CORE FUNC ---------- */
  function updateLimitedStockBadge(variantInput) {
    if (!variantInput || !variantInput.dataset) return;

    const variantId = variantInput.dataset.optionValueId;
    if (!variantId) return;

    const badge = getBadgeForInput(variantInput);
    if (!badge) return;

    const target = badge.querySelector('.limited-stock-badge__txt') || badge;
    const productId = badge.dataset.productId;
    const invCap    = +badge.dataset.maxInv || 20;
    if (!productId || invCap === 0) {
      badge.style.display = 'none'; return;
    }

    const now        = new Date();
    const hour       = now.getHours();
    const minute     = now.getMinutes();
    const day        = now.getDay();
    const isOpenDay  = day >= 0 && day <= 6;   // Sun–Sat
    const isOpenHour = hour >= OPEN_HOUR && hour < CLOSE_HOUR;
    const active     = isOpenDay && isOpenHour;

    const dateKey = todayStamp(now);
    const baseKey  = key('base',  productId, variantId, dateKey);
    const floorKey = key('floor', productId, variantId, dateKey);

    let base = load(baseKey, null);
    let floor = load(floorKey, null);
    if (base === null || floor === null) {
      base = Math.min(rand(START_MIN, START_MAX), invCap);
      floor = Math.min(rand(FLOOR_MIN, FLOOR_MAX), base);
      save(baseKey, base);
      save(floorKey, floor);
    }

    let qty;
    if (active) {
      const hrsSinceOpen = (hour + minute/60) - OPEN_HOUR;
      const progress = Math.min(Math.max(hrsSinceOpen / (PRE_CLOSE_HOUR - OPEN_HOUR), 0), 1);
      qty = Math.round(base - (base - floor) * progress);
    } else {
      qty = base; // fuera de horario, muestra base (stock “visible”)
    }

    qty = Math.max(1, Math.min(qty, invCap));
    const msg = active
      ? `Fresh batch – only ${qty} left for TODAY!`
      : `Baked fresh next day · ${qty} available`;

    target.textContent = msg;
    badge.style.display = 'inline-flex';

    const form = badge.closest('form');
    const button = form?.querySelector('.product-form__buttons button') || document.querySelector('.product-form__buttons button');
    const label = button?.querySelector('span') || button;
    if (!label) return;

    const updateForPreOrder = () => {
      const text = label.textContent?.trim() || '';
      if (isPreOrderText(text)) {
        target.textContent = 'Sold out';
      } else {
        target.textContent = msg;
      }
    };

    updateForPreOrder();

    if (!label.__lsbObserved) {
      const mo = new MutationObserver(() => updateForPreOrder());
      mo.observe(label, { childList: true, characterData: true, subtree: true });
      label.__lsbObserved = true;
    }
  }

  function initFromChecked(scope = document) {
    const checked = scope.querySelector('input[type="radio"][data-option-value-id]:checked')
                  || scope.querySelector('input[type="radio"][data-option-value-id]');
    if (checked) updateLimitedStockBadge(checked);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFromChecked());
  } else {
    initFromChecked();
  }

  const delegatedHandler = (e) => {
    const el = e.target?.closest?.(
      'input[type="radio"][data-option-value-id]'
    );
    if (el && (el.checked || e.type === 'click')) {
      requestAnimationFrame(() => updateLimitedStockBadge(el));
    }
  };
  document.addEventListener('change', delegatedHandler, true);
  document.addEventListener('click', delegatedHandler, true);

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (
          node.nodeType === 1 &&
          (node.matches?.('input[type="radio"][data-option-value-id]') ||
            node.querySelector?.('input[type="radio"][data-option-value-id]'))
        ) {
          initFromChecked(node.closest('form') || node);
          return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();